module.exports = require("./kam-KE.js");